// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`ModalComponent test Match con el snapshot 1`] = `
<transition-stub name="modal">
    <!---->
</transition-stub>
`;
